/**
 * Outlook identity for the active mailbox (pre-login routing signal).
 * Safe when Office.js is not loaded (e.g. partial test / harness).
 */
export function getMailboxEmailAddress(): string | null {
  try {
    if (
      typeof Office === 'undefined' ||
      !Office.context?.mailbox?.userProfile
    ) {
      return null;
    }
    const addr = Office.context.mailbox.userProfile.emailAddress;
    if (typeof addr === 'string' && addr.includes('@')) {
      return addr;
    }
  } catch {
    /* ignore */
  }
  return null;
}
